import { render, staticRenderFns } from "./Memory.vue?vue&type=template&id=7acef2a6&lang=pug&"
import script from "./Memory.vue?vue&type=script&lang=js&"
export * from "./Memory.vue?vue&type=script&lang=js&"
import style0 from "./Memory.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7acef2a6')) {
      api.createRecord('7acef2a6', component.options)
    } else {
      api.reload('7acef2a6', component.options)
    }
    module.hot.accept("./Memory.vue?vue&type=template&id=7acef2a6&lang=pug&", function () {
      api.rerender('7acef2a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/specific/Memory.vue"
export default component.exports